import React from 'react';
import { bool, string } from 'prop-types';
import clsx from 'clsx';
import { FormattedMessage } from '../../../../util/reactIntl';
import { propTypes } from '../../../../util/types';
import casaPicoRuivo from '../SectionBnbsWorkingWith/images/casa-pico-ruivo.png';
import madeiraLuxuryVillas from '../SectionBnbsWorkingWith/images/mlv.png';
import meuPeDeCacau from '../SectionBnbsWorkingWith/images/meu-pe-de-cacau.png';
import mupiMadeira from '../SectionBnbsWorkingWith/images/mupimadeira.png';
import museumHouse from '../SectionBnbsWorkingWith/images/museumhouse.png';
import petitHotels from '../SectionBnbsWorkingWith/images/petit.png';
import santaMaria from '../SectionBnbsWorkingWith/images/santamaria.png';
import saoFranciscoPlaceholder from '../SectionBnbsWorkingWith/images/saofranciscoplaceholder.png';
import stayInMadeira from '../SectionBnbsWorkingWith/images/stayinmadeira.png';
import vinteNoveMadeiraHostel from '../SectionBnbsWorkingWith/images/vintenovemadeirahostel.png';
import vistaOceanoPlaceholder from '../SectionBnbsWorkingWith/images/vistaoceanoplaceholder.png';

import { NamedLink } from'../../../../components';

import css from './SectionBnbsWorkingWith.module.css';

const SectionBnbsWorkingWith = props => {
  const { rootClassName, className } = props;

  const classes = clsx(rootClassName || css.root, className);
  return (
    <div className={classes}>
      <div className={css.title}>
        <FormattedMessage id="SectionSAProgramSummary.ourPartners" />
        <br />
      </div>

      <div>
        <div className={css.container}>
          <div className={css.content}>
            {/* Carousel Desktop */}

            <div className={css.slideshowMediumLargeScreens}>
              <button className={clsx(css.slideBtn, css.slideBtn1)}>1</button>
              <button className={clsx(css.slideBtn, css.slideBtn2)}>2</button>
              <button className={clsx(css.slideBtn, css.slideBtn3)}>3</button>
              {/* carousel wrapper which contains all images */}
              <div className={css.slideshowWrapper}>
                <div className={css.slide}>
                  <div className={css.logoWrapper}>
                    <img className={css.partnerLogo} src={santaMaria} alt="Santa Maria Hostel" />{' '}
                  </div>
                  <div className={css.logoWrapper}>
                    <img className={css.partnerLogo} src={museumHouse} alt="Museum House" />{' '}
                  </div>
                  <div className={css.logoWrapper}>
                    <img className={css.partnerLogo} src={meuPeDeCacau} alt="Meu Pé de Cacau" />{' '}
                  </div>
                  <div className={css.logoWrapper}>
                    <img className={css.partnerLogo} src={mupiMadeira} alt="MUPI Madeira" />{' '}
                  </div>
                </div>
                <div className={css.slide}>
                  <div className={css.logoWrapper}>
                    <img
                      className={css.partnerLogo}
                      src={casaPicoRuivo}
                      alt="Casa de Abrigo Pico Ruivo"
                    />{' '}
                  </div>
                  <div className={css.logoWrapper}>
                    {' '}
                    <img
                      className={css.partnerLogo}
                      src={vinteNoveMadeiraHostel}
                      alt="29 Madeira Hostel"
                    />{' '}
                  </div>
                  <div className={css.logoWrapper}>
                    {' '}
                    <img
                      className={css.partnerLogo}
                      src={madeiraLuxuryVillas}
                      alt="Madeira Luxury Villas"
                    />{' '}
                  </div>
                  <div className={css.logoWrapper}>
                    {' '}
                    <img className={css.partnerLogo} src={petitHotels} alt="Petit Hotels" />{' '}
                  </div>
                </div>

                <div className={css.slide}>
                  <div className={css.logoWrapper}>
                    <img className={css.partnerLogo} src={stayInMadeira} alt="Stay In Madeira" />{' '}
                  </div>
                  <div className={css.logoWrapper}>
                    <img
                      className={css.partnerLogo}
                      src={saoFranciscoPlaceholder}
                      alt="São Francisco Accommodation"
                    />{' '}
                  </div>
                  <div className={css.logoWrapper}>
                    <img
                      className={css.partnerLogo}
                      src={vistaOceanoPlaceholder}
                      alt="Vista Oceano Apartments"
                    />
                  </div>
                  <div className={css.logoWrapper}>
                    <span className={clsx(css.partnerLogo, css.partnerName)}>
                      {' '}
                      <FormattedMessage id="SectionBnbsWorkingWith.placeholder" />
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Mobile carousel */}
            <div className={css.slideshowSmallScreens}>
              {/* <button className={css.seeAllBtn}>See All</button> */}
              {/* carousel wrapper which contains all images */}
              <div className={css.slideshowWrapper}>
                <div className={css.slide}>
                  <div className={css.logoWrapper}>
                    <img className={css.partnerLogo} src={santaMaria} alt="Santa Maria Hostel" />{' '}
                  </div>
                </div>
                <div className={css.slide}>
                  <div className={css.logoWrapper}>
                    <img className={css.partnerLogo} src={museumHouse} alt="Museum House" />{' '}
                  </div>
                </div>
                <div className={css.slide}>
                  <div className={css.logoWrapper}>
                    <img className={css.partnerLogo} src={meuPeDeCacau} alt="Meu Pé de Cacau" />{' '}
                  </div>
                </div>
                <div className={css.slide}>
                  <div className={css.logoWrapper}>
                    <img className={css.partnerLogo} src={mupiMadeira} alt="MUPI Madeira" />{' '}
                  </div>
                </div>

                <div className={css.slide}>
                  <div className={css.logoWrapper}>
                    <img
                      className={css.partnerLogo}
                      src={casaPicoRuivo}
                      alt="Casa de Abrigo do Pico Ruivo"
                    />{' '}
                  </div>
                </div>
                <div className={css.slide}>
                  <div className={css.logoWrapper}>
                    <img
                      className={css.partnerLogo}
                      src={vinteNoveMadeiraHostel}
                      alt="29 Madeira Hostel"
                    />{' '}
                  </div>
                </div>
                <div className={css.slide}>
                  <div className={css.logoWrapper}>
                    <img
                      className={css.partnerLogo}
                      src={madeiraLuxuryVillas}
                      alt="Madeira Luxury Villas"
                    />{' '}
                  </div>
                </div>
                <div className={css.slide}>
                  <div className={css.logoWrapper}>
                    <img className={css.partnerLogo} src={petitHotels} alt="Petit Hotels" />{' '}
                  </div>
                </div>

                <div className={css.slide}>
                  <div className={css.logoWrapper}>
                    <img className={css.partnerLogo} src={stayInMadeira} alt="Stay In Madeira" />{' '}
                  </div>
                </div>
                <div className={css.slide}>
                  <div className={css.logoWrapper}>
                    <img
                      className={css.partnerLogo}
                      src={saoFranciscoPlaceholder}
                      alt="São Francisco Accommodation"
                    />{' '}
                  </div>
                </div>
                <div className={css.slide}>
                  <div className={css.logoWrapper}>
                    <img
                      className={css.partnerLogo}
                      src={vistaOceanoPlaceholder}
                      alt="Vista Oceano Apartments"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={css.heroButtonWrapper}>
        <NamedLink name="AffiliateSignupPage" className={css.heroBnbsButton}>
          <FormattedMessage id="SectionHeroSA.browseButton" />
        </NamedLink>
      </div>
    </div>
  );
};

SectionBnbsWorkingWith.defaultProps = {
  rootClassName: null,
  className: null,
  currentUserListing: null,
  currentUserListingFetched: false,
};

SectionBnbsWorkingWith.propTypes = {
  rootClassName: string,
  className: string,
  currentUserListing: propTypes.ownListing,
  currentUserListingFetched: bool,
};

export default SectionBnbsWorkingWith;
